import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ReportAgendaPro } from '../models/reportAgendaPro';
import { ReportService } from '../services/reportAgenda.service';
import { SelectItem } from 'primeng/api';
import { ConceptService } from '../services/concept.service';
import { Concept } from '../models/concept';
import { ServicePremiumService } from '../services/servicePremium.service';

@Component({
    selector: 'app-report-agenda',
    templateUrl: './reportAgendaPro.component.html',
    styleUrls: ['./reportAgendapro.component.css'],
    providers: [ServicePremiumService, ConceptService]
})

export class ReportAgendaProComponent implements OnInit {
    public cols: any[];
    public listreportAgenda: ReportAgendaPro[] = [];
    public listConcepts: Concept[] = [];
    public dropdownConcepto: SelectItem[];
    public loading: boolean;
    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _servicePremiumService: ServicePremiumService,
        private _conceptService: ConceptService
    ) {
        this.cols = [
            { field: 'nroTicket', header: 'Nro. Ticket' },
            { field: 'date', header: 'Fecha' },
            { field: 'mark', header: 'Marca' },
            { field: 'model', header: 'Modelo' },
            { field: 'imei', header: 'IMEI' },
            { field: 'failure', header: 'Falla' },
            { field: 'concept', header: 'Concepto' },
            { field: 'department', header: 'Departamento' },
            { field: 'city', header: 'Ciudad' },
            { field: 'address', header: 'Direccion' },
            { field: 'addressDesciption', header: 'Direccion Descripcion' },
            { field: 'name', header: 'Nombre' },
            { field: 'email', header: 'Correo' },
            { field: 'phone', header: 'Telefono' },
            { field: 'aceptPolicy', header: 'Acepta Envio' },
            { field: 'aceptShipping', header: 'Acepta Politica' },
            { field: 'latitude', header: 'Latitud' },
            { field: 'longitude', header: 'Longitud' },
            { field: 'entryRepair', header: 'Ing.Reparación' }
        ];
    }
    ngOnInit() {
        this.getAgenda();
        this.getConcepto();
    }
    getAgenda() {
        /*const dateIni = this.formatDate(new Date());
        const dateFin = this.formatDate(new Date());*/
        this.loading = true;
        this._servicePremiumService.get().subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    const listreportAgendaA: [] = response.object;
                    this.listreportAgenda = listreportAgendaA.reverse();
                    this.loading = false;
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = date.getMonth() +1;
        const day = date.getDate();
        if(month <=9 && day <=9) {
            return year + '0' + month + '0' + day;  
        } else if(month <=9 && day >9){
            return year  + '0' + month  + day;
        }  else if(month >9 && day <=9){
            return year   + month  + '0'  + day;
        } else {
            return year + '-'  + month + '-' + day;
        }
        
    }
    getConcepto() {
        this._conceptService.get().subscribe(
            response => {
                if (response.statusCode === '200 OK') {
                    this.listConcepts = response.object;
                    this.generateMultiSElectConcepto();
                } else {
                    console.log(response);
                }
            },
            error => {
                console.log(<any>error);
            }
        );
    }
    generateMultiSElectConcepto() {
        this.dropdownConcepto = [];
        for(const cp of this.listConcepts) {
            this.dropdownConcepto.push({label: cp.name, value: cp.id});
        }
    }
}